import axios from "axios";

export const PUBLIC_URL = "";

export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8080"
    : window.location.origin;

export const https = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});
